/** The private attention projection. Source systems retain decision and execution authority. */
export const ATTENTION_LIMITS = {
    items: 500,
    inventoryItems: 5000,
    pages: 10,
    readTargets: 100,
    options: 12,
    customAnswerCharacters: 2000,
    titleCharacters: 240,
    bodyCharacters: 4000,
};
//# sourceMappingURL=attention.js.map